import * as ng from 'angular';

ng.module('selfReg')
   .directive('validateEqual', validateEqualDirective);

export function validateEqualDirective() {
   return {
      require: 'ngModel',
      link: validateEqualLink,
      scope: {
         value: '=validateEqual'
      }
   }
}

function validateEqualLink(scope:ng.IScope, elm, attrs, ctrl:ng.INgModelController) {
   ctrl.$validators.equal = isValid;
   scope.$watch('value', onValueChange);

   function isValid(modelValue) {
      return ctrl.$isEmpty(modelValue) || !scope['value'] || modelValue === scope['value'];
   }

   function onValueChange() {
      ctrl.$validate();
   }
}
